import { useFormikContext } from "formik";
import { MediaManager } from "@/components";
import OrganizationSetting from "./Setting";
import get from 'lodash/get';
import { useAppSelector } from '@/hooks';
import { getThumbnailImage } from "@/utils/media";

interface Props {
    field: string;
    title: string;
    description: string;
}

const FileSetting = ({ field, title, description }: Props) => {
    const organizationId = useAppSelector((store) => store.ui.activeOrganization);
    
    const { values, setFieldValue } = useFormikContext<{
        logo: string;
        header: string;
    }>();

    return (
        <OrganizationSetting
            title={title}
            description={description}
        >
            <MediaManager
                value={getThumbnailImage({ file: get(values, field, undefined), organizationId })}
                onChange={(values) => setFieldValue(field, values[0])}
            />
        </OrganizationSetting>
    )
}

export default FileSetting;
